var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill stroke",
    d: "M70.043 47.11c0-13.461-10.912-24.39-24.353-24.39-13.44 0-24.352 10.929-24.352 24.39S32.25 71.5 45.69 71.5c4.49 0 8.893-1.243 12.721-3.592L70.043 71.5l-3.587-11.649a24.415 24.415 0 003.587-12.741z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M58.487 18.049a28.81 28.81 0 00-8.553-9.403M35.676 3.576a29.164 29.164 0 00-2.099-.076c-10.473 0-19.639 5.646-24.628 14.061a28.555 28.555 0 00-3.992 14.602 28.688 28.688 0 003.916 14.473L4.957 60.827l10.884-3.013M34.09 42.812h23.201M34.09 51.408h15.525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.1b95648deb9a4e169ae8682108128c87.svg";
export { ForwardRef as ReactComponent };